<template>
  <el-container class="main-container">
    <!-- 横跨全页的Header -->
    <el-header v-show="!isMobileLandscapeScreen" class="main-header">
      <div class="header-flex">
        <!-- 移动端：汉堡菜单按钮 -->
        <div v-if="isMobileView" class="mobile-menu-btn" @click="mobileDrawerVisible = true">
          <el-icon :size="18"><Fold /></el-icon>
        </div>
        <div class="header-logo">
          <img src="@/assets/logo-xmyk.png" alt="产品图标" class="logo" />
        </div>
        <div class="header-banner">
          <div v-if="!isMobileView" class="banner-icon">
            <el-icon><DataLine /></el-icon>
          </div>
          <div class="banner-text">
            <h2>锡林郭勒盟动物疫病预防控制中心<br class="mobile-br" />数字化智能工作平台</h2>
          </div>
        </div>
        <div class="user-info-container">
          <UserInfo />
        </div>
      </div>
    </el-header>
    <el-container>
      <!-- 左侧菜单 (桌面端) -->
      <el-aside v-if="!isMobileView" width="260px" class="aside-menu">
        <el-menu
          :default-active="activeMenu"
          router
          @select="handleMenuSelect"
          class="full-height-menu"
          background-color="transparent"
          text-color="#b8c5d3"
          active-text-color="#409eff"
        >
          <!-- 首页仪表盘 -->
          <el-menu-item v-if="false" index="dashboard" class="menu-item-custom">
            <el-icon><HomeFilled /></el-icon>
            <span>首页仪表盘</span>
          </el-menu-item>

          <!-- 数据任务 -->
          <el-sub-menu index="data-tasks" class="submenu-custom">
            <template #title>
              <el-icon><Edit /></el-icon>
              <span>数据任务</span>
            </template>
            <el-menu-item index="data-tasks/overview" class="menu-item-custom">
              <el-icon><DataLine /></el-icon>
              <span>数据汇总</span>
            </el-menu-item>
            <el-menu-item
              v-if="showFillMenu"
              index="data-tasks/fill"
              class="menu-item-custom"
            >
              <el-icon><EditPen /></el-icon>
              <span>数据填报</span>
              <el-badge
                v-if="todoCounts.filling > 0"
                :value="todoCounts.filling"
                class="menu-badge"
              />
            </el-menu-item>
            <el-menu-item
              v-if="showCountyApprovalMenu"
              index="data-tasks/county-approval"
              class="menu-item-custom"
            >
              <el-icon><Check /></el-icon>
              <span>报表审批</span>
              <el-badge
                v-if="todoCounts.county_approval > 0"
                :value="todoCounts.county_approval"
                class="menu-badge"
              />
            </el-menu-item>
            <el-menu-item
              v-if="showReportConfigMenu"
              index="data-tasks/report-config"
              class="menu-item-custom"
            >
              <el-icon><DocumentChecked /></el-icon>
              <span>报表配置管理</span>
            </el-menu-item>
          </el-sub-menu>

          <!-- 数据分析 -->
          <el-sub-menu
            v-if="showAnalysisMenu"
            index="data-analysis"
            class="submenu-custom"
          >
            <template #title>
              <el-icon><DataAnalysis /></el-icon>
              <span>数据分析</span>
            </template>
            <el-menu-item
              index="data-tasks/analysis"
              class="menu-item-custom"
            >
              <el-icon><DataAnalysis /></el-icon>
              <span>屠宰科分析</span>
            </el-menu-item>
            <el-menu-item
              index="data-tasks/public-health-analysis"
              class="menu-item-custom"
            >
              <el-icon><DataAnalysis /></el-icon>
              <span>公共卫生科分析</span>
            </el-menu-item>
            <el-menu-item
              index="data-tasks/cdc-analysis"
              class="menu-item-custom"
            >
              <el-icon><DataAnalysis /></el-icon>
              <span>疫情防控科分析</span>
            </el-menu-item>
          </el-sub-menu>

          <!-- 数字大屏 -->
          <el-sub-menu
            v-if="showDataScreenMenu"
            index="data-screen"
            class="submenu-custom"
          >
            <template #title>
              <el-icon><PieChart /></el-icon>
              <span>数字大屏</span>
            </template>
            <el-menu-item
              index="data-tasks/league-overview-screen"
              class="menu-item-custom"
            >
              <el-icon><PieChart /></el-icon>
              <span>盟中心数字大屏</span>
            </el-menu-item>
            <el-menu-item
              index="data-tasks/screen"
              class="menu-item-custom"
            >
              <el-icon><PieChart /></el-icon>
              <span>屠宰科数字大屏</span>
            </el-menu-item>
            <el-menu-item
              index="data-tasks/public-health-screen"
              class="menu-item-custom"
            >
              <el-icon><PieChart /></el-icon>
              <span>公共卫生科数字大屏</span>
            </el-menu-item>
            <el-menu-item
              index="data-tasks/cdc-screen"
              class="menu-item-custom"
            >
              <el-icon><PieChart /></el-icon>
              <span>疫情防控科数字大屏</span>
            </el-menu-item>
          </el-sub-menu>

          <!-- 项目管理 -->
          <el-sub-menu
            v-if="userInfo.user_dept_type === 2 || userInfo.user_type === 1"
            index="report"
            class="submenu-custom"
          >
            <template #title>
              <el-icon><Document /></el-icon>
              <span>项目管理</span>
            </template>
            <!-- 数据项目 -->
            <el-menu-item index="data-project" class="menu-item-custom">
              <el-icon><MessageBox /></el-icon>
              <span>数据项目</span>
            </el-menu-item>
            <!-- 数据模板 -->
            <el-menu-item
              v-if="userInfo.user_type === 1"
              index="report-templates"
              class="menu-item-custom"
            >
              <el-icon><Files /></el-icon>
              <span>数据模板</span>
            </el-menu-item>
          </el-sub-menu>

          <!-- 用户管理 -->
          <el-menu-item
            v-if="userInfo.user_type === 1 || userInfo.user_type === 2 || userInfo.user_dept_type === 2"
            index="user-management"
            class="menu-item-custom"
          >
            <el-icon><User /></el-icon>
            <span>用户管理</span>
          </el-menu-item>

          <!-- 中心知识库 -->
          <el-menu-item
            v-if="userInfo.user_dept_type === 2 || userInfo.user_type === 1"
            index="knowledge-base"
            class="menu-item-custom"
          >
            <el-icon><Folder /></el-icon>
            <span>中心知识库</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-main
        class="main-body"
        :class="{ 'mobile-landscape': isMobileLandscapeScreen }"
      >
        <!-- 移动端横屏大屏：悬浮返回按钮 -->
        <div v-if="isMobileLandscapeScreen" class="landscape-back-btn" @click="$router.push('/main/data-tasks/overview')">
          <el-icon :size="16"><ArrowLeft /></el-icon>
          <span>返回</span>
        </div>
        <router-view></router-view>
      </el-main>

      <!-- 移动端：侧边抽屉导航 -->
      <teleport to="body">
        <transition name="drawer-fade">
          <div v-if="isMobileView && mobileDrawerVisible" class="mobile-drawer-overlay" @click="mobileDrawerVisible = false"></div>
        </transition>
        <transition name="drawer-slide">
          <div v-if="isMobileView && mobileDrawerVisible" class="mobile-drawer">
            <div class="mobile-drawer-header">
              <span class="mobile-drawer-title">数字化智能工作平台</span>
              <div class="mobile-drawer-close" @click="mobileDrawerVisible = false">
                <el-icon :size="20"><Close /></el-icon>
              </div>
            </div>
            <div class="mobile-drawer-body">
              <template v-for="group in mobileMenuGroups" :key="group.label">
                <div
                  v-if="group.visible !== false"
                  class="mobile-menu-group"
                >
                  <!-- 直接导航项（无子菜单，如用户管理） -->
                  <div
                    v-if="group.index"
                    class="mobile-menu-item direct-item"
                    :class="{ active: activeMenu === group.index }"
                    @click="handleMobileNavSelect(group.index)"
                  >
                    <el-icon :size="16"><component :is="group.icon" /></el-icon>
                    <span>{{ group.label }}</span>
                  </div>
                  <!-- 有子菜单的分组 -->
                  <template v-else>
                    <div
                      class="mobile-menu-group-title"
                      @click="group.children ? toggleMobileGroup(group.label) : null"
                    >
                      <el-icon :size="16"><component :is="group.icon" /></el-icon>
                      <span>{{ group.label }}</span>
                      <el-icon v-if="group.children" class="mobile-group-arrow" :class="{ expanded: expandedMobileGroups.includes(group.label) }">
                        <ArrowRight />
                      </el-icon>
                    </div>
                    <!-- 折叠展开子菜单 -->
                    <transition name="group-expand">
                      <div v-if="group.children && expandedMobileGroups.includes(group.label)" class="mobile-menu-children">
                        <div
                          v-for="item in group.children.filter(i => i.visible !== false)"
                          :key="item.index"
                          class="mobile-menu-item"
                          :class="{ active: activeMenu === item.index }"
                          @click="handleMobileNavSelect(item.index)"
                        >
                          <el-icon :size="16"><component :is="item.icon" /></el-icon>
                          <span>{{ item.label }}</span>
                          <el-badge
                            v-if="item.count > 0"
                            :value="item.count"
                            :max="99"
                            class="mobile-menu-badge"
                          />
                        </div>
                      </div>
                    </transition>
                  </template>
                </div>
              </template>
            </div>
          </div>
        </transition>
      </teleport>
    </el-container>
  </el-container>
</template>

<script>
import {
  HomeFilled,
  Document,
  Edit,
  MessageBox,
  User,
  Files,
  Folder,
  DataLine,
  PieChart,
  EditPen,
  Check,
  DocumentChecked,
  DataAnalysis,
  Operation,
  Fold,
  Close,
  ArrowRight,
  ArrowLeft,
} from "@element-plus/icons-vue";
import UserInfo from "./UserInfo.vue";
import { getUserTodoCount } from "@/api/user-management/user";

export default {
  name: "MainLayout",
  components: {
    HomeFilled,
    Document,
    Edit,
    MessageBox,
    User,
    Files,
    Folder,
    DataLine,
    PieChart,
    EditPen,
    Check,
    DocumentChecked,
    DataAnalysis,
    UserInfo,
    Operation,
    Fold,
    Close,
    ArrowRight,
    ArrowLeft,
  },
  data() {
    return {
      userInfo: null,
      todoCounts: {
        filling: 0,
        county_approval: 0,
        center_approval: 0,
      },
      isMobileView: false,
      mobileDrawerVisible: false,
      expandedMobileGroups: [],
    };
  },
  computed: {
    activeMenu() {
      const routePath = this.$route.path;
      if (routePath.startsWith("/main/")) {
        return routePath.split("/main/")[1];
      }
      return "data-tasks/overview";
    },
    isMobileLandscapeScreen() {
      return this.isMobileView && this.$route.path.endsWith("screen");
    },
    mobileMenuGroups() {
      return [
        {
          label: "数据任务",
          icon: Edit,
          children: [
            { label: "数据汇总", icon: DataLine, index: "data-tasks/overview", count: 0 },
            ...(this.showFillMenu
              ? [{ label: "数据填报", icon: EditPen, index: "data-tasks/fill", count: this.todoCounts.filling }]
              : []),
            ...(this.showCountyApprovalMenu
              ? [{ label: "报表审批", icon: Check, index: "data-tasks/county-approval", count: this.todoCounts.county_approval }]
              : []),
            ...(this.showReportConfigMenu
              ? [{ label: "报表配置管理", icon: DocumentChecked, index: "data-tasks/report-config", count: 0 }]
              : []),
          ],
        },
        {
          label: "数据分析",
          icon: DataAnalysis,
          visible: this.showAnalysisMenu,
          children: [
            { label: "屠宰科分析", icon: DataAnalysis, index: "data-tasks/analysis", count: 0 },
            { label: "公共卫生科分析", icon: DataAnalysis, index: "data-tasks/public-health-analysis", count: 0 },
            { label: "疫情防控科分析", icon: DataAnalysis, index: "data-tasks/cdc-analysis", count: 0 },
          ],
        },
        {
          label: "数字大屏",
          icon: PieChart,
          visible: this.showDataScreenMenu,
          children: [
            { label: "盟中心数字大屏", icon: PieChart, index: "data-tasks/league-overview-screen", count: 0 },
            { label: "屠宰科数字大屏", icon: PieChart, index: "data-tasks/screen", count: 0 },
            { label: "公共卫生科数字大屏", icon: PieChart, index: "data-tasks/public-health-screen", count: 0 },
            { label: "疫情防控科数字大屏", icon: PieChart, index: "data-tasks/cdc-screen", count: 0 },
          ],
        },
        {
          label: "项目管理",
          icon: Document,
          visible: this.userInfo?.user_dept_type === 2 || this.userInfo?.user_type === 1,
          children: [
            { label: "数据项目", icon: MessageBox, index: "data-project", count: 0 },
            { label: "数据模板", icon: Files, index: "report-templates", count: 0, visible: this.userInfo?.user_type === 1 },
          ],
        },
        {
          label: "用户管理",
          icon: User,
          visible: this.userInfo?.user_type === 1 || this.userInfo?.user_type === 2 || this.userInfo?.user_dept_type === 2,
          index: "user-management",
        },
        {
          label: "中心知识库",
          icon: Folder,
          visible: this.userInfo?.user_dept_type === 2 || this.userInfo?.user_type === 1,
          index: "knowledge-base",
        },
      ];
    },
    showFillMenu() {
      return this.userInfo?.user_dept_type !== 2 && this.userInfo?.user_type !== 1;
    },
    showDataScreenMenu() {
      return this.showAnalysisMenu;
    },
    showAnalysisMenu() {
      return (
        this.userInfo?.user_type === 1 ||
        (this.userInfo?.user_type === 2 && (this.userInfo?.user_dept_type === 2 || this.userInfo?.user_dept_type === 3))
      );
    },
    showCountyApprovalMenu() {
      return true;
    },
    showReportConfigMenu() {
      return this.userInfo?.user_dept_type === 2 || this.userInfo?.user_type === 1;
    },
  },
  created() {
    this.fetchTodoCounts();
    const userInfoStr = localStorage.getItem("userInfo");
    this.userInfo = JSON.parse(userInfoStr);
    this.timer = setInterval(this.fetchTodoCounts, 60000);

    this.checkIfMobile();
    window.addEventListener("resize", this.checkIfMobile);
  },
  beforeUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    window.removeEventListener("resize", this.checkIfMobile);
  },
  watch: {
    $route: {
      handler() {
        this.fetchTodoCounts();
      },
      immediate: true,
    },
  },
  methods: {
    handleMenuSelect(index) {
      this.$router.push(`/main/${index}`);
    },
    handleMobileNavSelect(index) {
      this.$router.push(`/main/${index}`);
      this.mobileDrawerVisible = false;
    },
    toggleMobileGroup(label) {
      const idx = this.expandedMobileGroups.indexOf(label);
      if (idx >= 0) {
        this.expandedMobileGroups.splice(idx, 1);
      } else {
        this.expandedMobileGroups.push(label);
      }
    },
    async fetchTodoCounts() {
      try {
        const res = await getUserTodoCount();
        this.todoCounts = res.data;
      } catch (error) {
        console.error("获取待办数量失败:", error);
      }
    },
    checkIfMobile() {
      this.isMobileView = window.innerWidth <= 768;
      if (!this.isMobileView) {
        this.mobileDrawerVisible = false;
      }
    },
  },
};
</script>

<style scoped>
.main-container {
  height: 100vh;
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
  position: relative;
  padding-top: 100px;
}

.main-container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="50" cy="50" r="1" fill="rgba(255,255,255,0.1)"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
  opacity: 0.3;
  pointer-events: none;
}

.main-content {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 0px 20px 20px 0px;
  margin: 10px 10px 10px 0;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.main-header {
  color: white;
  height: 100px !important;
  line-height: 100px;
  padding: 0 30px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100vw;
  z-index: 100;
  overflow: hidden;
  display: flex;
  align-items: center;
  border-radius: 0;
}

.header-flex {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
}

.header-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  margin: 0 80px 0 50px;
}

.logo {
  width: 100px;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.header-banner {
  display: flex;
  align-items: center;
  gap: 15px;
  flex: 1;
  min-width: 0;
}

.banner-icon {
  width: 50px;
  height: 50px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  flex-shrink: 0;
}

.banner-icon .el-icon {
  font-size: 24px;
  color: white;
}

.banner-text h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.banner-text h2 .mobile-br {
  display: none;
}

.user-info-container {
  margin-left: 32px;
  z-index: 1;
  position: relative;
  display: flex;
  align-items: center;
  height: 100%;
  flex-shrink: 0;
}

/* 移动端汉堡菜单按钮 */
.mobile-menu-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  cursor: pointer;
  flex-shrink: 0;
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
}
.mobile-menu-btn:active {
  background: rgba(255, 255, 255, 0.3);
}

.aside-menu {
  height: calc(100vh - 100px);
  background: linear-gradient(180deg, #1e3c72 0%, #2a5298 100%);
  border-radius: 20px 0px 0px 20px;
  margin: 0px 0px 0px 10px;
  box-shadow: 4px 0 20px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.aside-menu::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    45deg,
    transparent 40%,
    rgba(255, 255, 255, 0.05) 50%,
    transparent 60%
  );
}

.full-height-menu {
  height: calc(100% - 120px);
  border: none;
  background: transparent;
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1;
  min-height: 0;
}

.main-body {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 30px;
  height: calc(100vh - 100px);
  overflow-y: auto;
  position: relative;
  border-radius: 0 20px 20px 0;
  margin-right: 10px;
}

.main-body::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="dots" width="20" height="20" patternUnits="userSpaceOnUse"><circle cx="10" cy="10" r="1" fill="rgba(0,0,0,0.05)"/></pattern></defs><rect width="100" height="100" fill="url(%23dots)"/></svg>');
  pointer-events: none;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  z-index: 1;
  position: relative;
}

/* 自定义菜单样式 */
:deep(.menu-item-custom) {
  margin: 4px 12px;
  border-radius: 8px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

:deep(.menu-item-custom::before) {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.1),
    transparent
  );
  transition: left 0.5s ease;
}

:deep(.menu-item-custom:hover::before) {
  left: 100%;
}

:deep(.menu-item-custom:hover) {
  background: rgba(255, 255, 255, 0.1) !important;
  transform: translateX(5px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

:deep(.menu-item-custom.is-active) {
  background: linear-gradient(135deg, #409eff 0%, #36a3f7 100%) !important;
  color: white !important;
  box-shadow: 0 4px 15px rgba(64, 158, 255, 0.4);
}

:deep(.submenu-custom .el-sub-menu__title) {
  margin: 4px 12px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

:deep(.submenu-custom .el-sub-menu__title:hover) {
  background: rgba(255, 255, 255, 0.1) !important;
  transform: translateX(5px);
}

:deep(.submenu-custom.is-active .el-sub-menu__title) {
  background: rgba(255, 255, 255, 0.1) !important;
  color: #409eff !important;
}

:deep(.el-menu-item .el-badge) {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
}

:deep(.el-menu-item .el-badge__content) {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%);
  border: 2px solid white;
  box-shadow: 0 2px 8px rgba(255, 107, 107, 0.4);
}

.menu-badge {
  display: flex;
  align-items: center;
}

.preview-tag {
  margin-left: 8px;
  font-size: 10px;
  height: 18px;
  line-height: 16px;
  padding: 0 6px;
  background: linear-gradient(135deg, #909399 0%, #a6a9ad 100%);
  border: none;
  color: white;
  border-radius: 6px;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .aside-menu {
    width: 220px !important;
  }
}

/* ========== 移动端适配 ========== */
@media (max-width: 768px) {
  .main-container {
    padding-top: 56px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  }

  .main-header {
    height: 56px !important;
    line-height: 56px;
    padding: 0 12px;
  }

  .header-flex {
    gap: 10px;
  }

  .header-logo {
    margin: 0;
    height: auto;
  }

  .logo {
    width: 36px;
    height: 36px;
    object-fit: contain;
    border-radius: 8px;
  }

  .header-banner {
    gap: 0;
    min-width: 0;
    flex: 1;
  }

  .banner-text h2 {
    font-size: 12px;
    font-weight: 600;
    line-height: 1.5;
    white-space: normal;
  }

  .banner-text h2 .mobile-br {
    display: inline;
  }

  .user-info-container {
    margin-left: 8px;
    flex-shrink: 0;
  }

  .main-body {
    height: calc(100vh - 56px);
    padding: 12px;
    border-radius: 0;
    margin-right: 0;
  }

  /* 移动端大屏横屏模式 */
  .main-body.mobile-landscape {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vh;
    height: 100vw;
    transform: rotate(90deg);
    transform-origin: top left;
    translate: 100vw 0;
    padding: 8px;
    margin: 0;
    border-radius: 0;
    z-index: 200;
    overflow-y: auto;
  }

  .landscape-back-btn {
    position: fixed;
    top: 8px;
    left: 8px;
    z-index: 300;
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 6px 12px;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    border-radius: 20px;
    font-size: 12px;
    cursor: pointer;
    backdrop-filter: blur(8px);
    border: 1px solid rgba(255, 255, 255, 0.2);
  }
  .landscape-back-btn:active {
    background: rgba(0, 0, 0, 0.7);
  }

  .main-container:has(.mobile-landscape) {
    padding-top: 0;
  }
}

/* ========== 移动端抽屉导航 ========== */
.mobile-drawer-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 2000;
}

.mobile-drawer {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 280px;
  max-width: 80vw;
  background: linear-gradient(180deg, #1e3c72 0%, #2a5298 100%);
  z-index: 2001;
  display: flex;
  flex-direction: column;
  box-shadow: 4px 0 24px rgba(0, 0, 0, 0.3);
}

.mobile-drawer-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  flex-shrink: 0;
}

.mobile-drawer-logo {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  object-fit: cover;
}

.mobile-drawer-title {
  color: white;
  font-size: 16px;
  font-weight: 600;
  flex: 1;
}

.mobile-drawer-close {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  border-radius: 8px;
  transition: background 0.2s;
}
.mobile-drawer-close:active {
  background: rgba(255, 255, 255, 0.15);
}

.mobile-drawer-body {
  flex: 1;
  overflow-y: auto;
  padding: 8px 0;
  -webkit-overflow-scrolling: touch;
}

.mobile-menu-group {
  margin-bottom: 2px;
}

.mobile-menu-group-title {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  cursor: pointer;
  user-select: none;
  transition: color 0.2s;
}
.mobile-menu-group-title:active {
  color: rgba(255, 255, 255, 0.85);
}

.mobile-group-arrow {
  margin-left: auto;
  font-size: 12px;
  transition: transform 0.25s ease;
}
.mobile-group-arrow.expanded {
  transform: rotate(90deg);
}

.mobile-menu-children {
  overflow: hidden;
}

.mobile-menu-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 11px 16px 11px 42px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
}
.mobile-menu-item.direct-item {
  padding-left: 16px;
  font-size: 13px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.6);
}
.mobile-menu-item:active {
  background: rgba(255, 255, 255, 0.08);
}
.mobile-menu-item.active {
  color: #fff;
  background: linear-gradient(135deg, rgba(64, 158, 255, 0.35) 0%, rgba(54, 163, 247, 0.25) 100%);
}
.mobile-menu-item.active::before {
  content: "";
  position: absolute;
  left: 0;
  top: 4px;
  bottom: 4px;
  width: 3px;
  border-radius: 0 3px 3px 0;
  background: #409eff;
}

.mobile-menu-badge {
  margin-left: auto;
}
.mobile-menu-badge :deep(.el-badge__content) {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%);
  border: none;
  box-shadow: 0 2px 6px rgba(255, 107, 107, 0.4);
}

/* 抽屉动画 */
.drawer-fade-enter-active,
.drawer-fade-leave-active {
  transition: opacity 0.25s ease;
}
.drawer-fade-enter-from,
.drawer-fade-leave-to {
  opacity: 0;
}

.drawer-slide-enter-active,
.drawer-slide-leave-active {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.drawer-slide-enter-from,
.drawer-slide-leave-to {
  transform: translateX(-100%);
}

/* 分组展开动画 */
.group-expand-enter-active,
.group-expand-leave-active {
  transition: all 0.25s ease;
  max-height: 500px;
}
.group-expand-enter-from,
.group-expand-leave-to {
  max-height: 0;
  opacity: 0;
}

/* 自定义滚动条样式 */
:deep(.el-menu)::-webkit-scrollbar {
  width: 6px;
}

:deep(.el-menu)::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 3px;
}

:deep(.el-menu)::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #409eff 0%, #36a3f7 100%);
  border-radius: 3px;
}

:deep(.el-menu)::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #36a3f7 0%, #409eff 100%);
}

/* 主内容区域滚动条 */
.main-body::-webkit-scrollbar {
  width: 8px;
}

.main-body::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
}

.main-body::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 4px;
}

.main-body::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
}

.mobile-drawer-body::-webkit-scrollbar {
  width: 4px;
}
.mobile-drawer-body::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 2px;
}

/* 菜单项图标动画 */
:deep(.menu-item-custom .el-icon) {
  transition: transform 0.3s ease;
}

:deep(.menu-item-custom:hover .el-icon) {
  transform: scale(1.1);
}

/* 子菜单展开动画 */
:deep(.el-sub-menu .el-menu) {
  background: rgba(0, 0, 0, 0.1) !important;
  border-radius: 8px;
  margin: 4px 12px;
  overflow: hidden;
}

/* 徽章动画 */
:deep(.el-badge__content) {
  animation: badgePulse 2s infinite;
}

@keyframes badgePulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

/* 加载动画 */
.main-container::after {
  content: "";
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: linear-gradient(90deg, #667eea, #764ba2, #409eff);
  background-size: 200% 100%;
  animation: loadingBar 3s ease-in-out infinite;
  z-index: 9999;
}

@keyframes loadingBar {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* 玻璃态效果增强 */
.main-content {
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
}

.aside-menu {
  box-shadow: 4px 0 20px rgba(0, 0, 0, 0.1), 0 0 0 1px rgba(255, 255, 255, 0.1);
}

/* 悬停效果增强 */
:deep(.menu-item-custom:hover) {
  background: rgba(255, 255, 255, 0.15) !important;
  transform: translateX(5px) scale(1.02);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(255, 255, 255, 0.2);
}

/* 活跃状态增强 */
:deep(.menu-item-custom.is-active) {
  background: linear-gradient(135deg, #409eff 0%, #36a3f7 100%) !important;
  color: white !important;
  box-shadow: 0 4px 15px rgba(64, 158, 255, 0.4),
    0 0 0 1px rgba(255, 255, 255, 0.3);
  transform: translateX(5px);
}

:deep(.el-menu) {
  --el-menu-level-padding: 0px;
}
</style>

<!-- 非 scoped 样式：穿透子组件的移动端横屏布局覆盖 -->
<style>
/* 移动端横屏：修正大屏页面高度，允许滚动 */
.main-body.mobile-landscape .data-screen-page {
  height: auto !important;
  min-height: 100% !important;
  overflow: visible !important;
}

/* 移动端横屏：左侧汇总栏保持窄列 */
.main-body.mobile-landscape .content-grid {
  grid-template-columns: 140px 1fr !important;
}

/* 移动端横屏：图表网格改为一行2个 */
.main-body.mobile-landscape .charts-grid {
  grid-template-columns: repeat(2, 1fr) !important;
  grid-template-rows: auto !important;
  min-height: 0 !important;
}

/* 移动端横屏：CDC大屏的 chart-column 改为纵向排列 */
.main-body.mobile-landscape .chart-column {
  grid-row: auto !important;
  grid-template-rows: auto auto auto !important;
}

/* 移动端横屏：图表卡片给一个合理的最小高度 */
.main-body.mobile-landscape .chart-card {
  min-height: 200px !important;
}

/* 移动端横屏：图表容器最小高度 */
.main-body.mobile-landscape .chart-container {
  min-height: 250px !important;
}

/* 移动端横屏：隐藏全屏按钮 */
.main-body.mobile-landscape .fullscreen-btn {
  display: none !important;
}
</style>
